// Cumulus path taken from Skysight's own emoji-style cloud icon. Single shape
// drawn at three sizes; outline stroke gives it a slight dimensional pop on
// any background.
const CUMULUS_PATH = 'M15.9345,30.2552c-0.0372,0.4242-0.3809,0.7675-0.8065,0.8131C9.9685,31.621,6,36.7013,6,42.8852 c0,6.553,4.5445,11.8652,10.1505,11.8652h38.6977C61.0072,54.7504,66,49.1365,66,42.2114c0-6.6366-4.5855-12.069-10.3883-12.5101 c-0.4439-0.0337-0.804-0.3445-0.8887-0.7793c-1.2963-6.6567-7.2763-11.659-14.3464-11.659c-4.5948,0-8.6879,2.0802-11.3459,5.3894 c-0.2597,0.3234-0.6956,0.4715-1.079,0.3107c-1.0228-0.4289-2.103-0.6365-3.3117-0.6365 C20.0727,22.3266,16.3237,25.8122,15.9345,30.2552z';
const CUMULUS_VIEWBOX = '0 0 72 72';

// Tuned to roughly match Skysight's ratio of ~20% of chart height for the
// largest cumulus. Smaller variants step down for fair-weather wisps.
const SIZE_BY_VARIANT = {
    'cumulus-small': 14,
    'cumulus-medium': 20,
    'cumulus-large': 26,
};

export const variantForOktas = (oktas) => {
    if (oktas <= 2) return 'cumulus-small';
    if (oktas <= 5) return 'cumulus-medium';
    return 'cumulus-large';
};

const CloudIcon = ({ variant = 'cumulus-medium', size, fill = '#FFFFFF', stroke = '#0f172a', x = 0, y = 0 }) => {
    const finalSize = size || SIZE_BY_VARIANT[variant] || SIZE_BY_VARIANT['cumulus-medium'];

    return (
        <svg
            x={x - finalSize / 2}
            y={y - finalSize / 2}
            width={finalSize}
            height={finalSize}
            viewBox={CUMULUS_VIEWBOX}
            overflow="visible"
        >
            <path d={CUMULUS_PATH} fill={fill} stroke={stroke} strokeWidth={1.5} vectorEffect="non-scaling-stroke" />
        </svg>
    );
};

export default CloudIcon;
